// import BaseCarousel from '@/molecules/BaseCarousel'
import React, { useContext } from 'react'

import * as S from './styles'
import ProductCard from '@/molecules/ProductCard'
import dynamic from 'next/dynamic'
import SectionThemeContext from '@contexts/SectionTheme'
import { Container } from '@/atoms/Grid'
import Image from 'next/image'

const BaseCarousel = dynamic(() => import('@/molecules/BaseCarousel'))

const BlogSlider = ({ items, theme = 'white', title, description, image }) => {
  const colorScheme = useContext(SectionThemeContext) || theme

  return (
    <S.BlogSlider>
      <Container>
        <S.BlogSliderWrapper>
          {image ? (
            <S.ImageContainer>
              <Image
                src={image.url}
                alt={image.alt}
                fill
                sizes='(max-width: 768px) 50vw, (max-width: 1200px) 50vw, 33vw'
              />
            </S.ImageContainer>
          ) : null}
          <S.BlogSliderContent>
            {title ? <S.BlogSliderTitle bold typo="displaySM">{title.content}</S.BlogSliderTitle> : null}
            {description ? (
              <S.BlogSliderDescription>{description}</S.BlogSliderDescription>
            ) : null}
          </S.BlogSliderContent>
          {items && items.length > 0 ? (
            <BaseCarousel
              theme={colorScheme}
              swiperProps={{
                spaceBetween: 24,
                slidesPerView: 1.2,
                breakpoints: {
                  768: {
                    slidesPerView: 1.2,
                  },
                  992: {
                    slidesPerView: 2.2,
                  },
                },
              }}
            >
              {items.map((item, i) => {
                return (
                  <S.StyledSwiperSlide key={i}>
                    <ProductCard
                      {...item}
                      colorScheme={colorScheme}
                    />
                  </S.StyledSwiperSlide>
                )
              })}
            </BaseCarousel>
          ) : null}
        </S.BlogSliderWrapper>
      </Container>
    </S.BlogSlider>
  )
}

export default BlogSlider
